import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import settings from '../../../settings';

const favicon = `${settings.IMAGES_BASE_URL}/images/favicon/bmw-favicon.png`;
function SEO({ lang, meta, title, description }) {
  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `description`,
          content: description || `Come to the BMW U.S. Rider Academy for BMW Motorrad On- and off-road school, and Custom Moto Tours. Ride the latest BMW Motorcycles.`
        },
        {
          property: `og:title`,
          content: title
        },
        {
          property: `og:description`,
          content: description || `Come to the BMW U.S. Rider Academy for BMW Motorrad On- and off-road school, and Custom Moto Tours. Ride the latest BMW Motorcycles.`
        }
      ].concat(meta)}
    >
      <link rel="icon" href={favicon} />
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
};

export default SEO;
